<template>
      <h1>AfCampaignsApprove</h1>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style scoped>

</style>
